<div [formGroup]="addressForm" class="address-component">
  <div class="form-group">
    <div class="form-control">
      <label for="country">{{ "COUNTRY" | translate }} {{ required ? '*' : '' }}</label>
      <p-dropdown
        [options]="countries"
        name="country"
        appendTo="body"
        (onChange)="onCountryChange($event.value)"
        formControlName="country"
        [filter]="true"
        placeholder="Selecione..."
        [pTooltip]="getErrorTooltip(addressForm.get('country'))"
        tooltipPosition="bottom"
      >
      </p-dropdown>
      <!-- <small
        *ngIf="addressForm?.get('country')?.touched && addressForm?.get('country')?.errors?.required"
        class="p-error block"
      >
        País Obrigatório
      </small> -->
    </div>

    <div class="form-control">
      <label for="zip">{{ "ZIP" | translate }} {{ required ? '*' : '' }}</label>
      <ng-container *ngIf="zipMask; else freeZipInput">
        <p-inputMask
          type="text"
          name="zip"
          formControlName="zip"
          (onComplete)="getCep()"
          (onBlur)="getCep()"
          maxlength="10"
          [mask]="zipMask"
          [pTooltip]="getErrorTooltip(addressForm.get('zip'))"
          tooltipPosition="bottom"
        ></p-inputMask>
      </ng-container>
      <ng-template #freeZipInput>
        <input
          pInputText
          type="text"
          name="zip"
          formControlName="zip"
          (blur)="getCep()"
          [pTooltip]="getErrorTooltip(addressForm.get('zip'))"
          tooltipPosition="bottom"
          maxlength="10"
        />
      </ng-template>
      <!-- <small
        *ngIf="addressForm?.get('zip')?.touched && addressForm?.get('zip')?.errors?.required"
        class="p-error block"
      >
        CEP Obrigatório
      </small> -->
    </div>

    <div class="form-control">
      <label for="state">{{ "FS" | translate }} {{ required ? '*' : '' }}</label>
      <p-dropdown
        [options]="states"
        name="state"
        appendTo="body"
        (onChange)="loadCities(addressForm.get('country').value, $event.value)"
        formControlName="state"
        [filter]="true"
        placeholder="Selecione..."
        [pTooltip]="getErrorTooltip(addressForm.get('state'))"
        tooltipPosition="bottom"
      >
      </p-dropdown>
      <!-- <small
        *ngIf="addressForm?.get('state')?.touched && addressForm?.get('state')?.errors?.required"
        class="p-error block"
      >
        Estado Obrigatório
      </small> -->
    </div>
  </div>

  <div class="form-group">
    <div class="form-control">
      <label for="city">{{ "CITY" | translate }} {{ required ? '*' : '' }}</label>
      <p-dropdown
        [options]="cities"
        name="city"
        appendTo="body"
        formControlName="city"
        [filter]="true"
        placeholder="Selecione..."
        [pTooltip]="getErrorTooltip(addressForm.get('city'))"
        tooltipPosition="bottom"
      >
      </p-dropdown>
      <!-- <small
        *ngIf="addressForm?.get('city')?.touched && addressForm?.get('city')?.errors?.required"
        class="p-error block"
      >
        Cidade Obrigatória
      </small> -->
    </div>

    <div class="form-control">
      <label for="district">{{ "DISTRICT" | translate }} {{ required ? '*' : '' }}</label>
      <input
        pInputText
        name="district"
        formControlName="district"
        maxlength="50"
        [pTooltip]="getErrorTooltip(addressForm.get('district'))"
        tooltipPosition="bottom"
      />
      <!-- <small
        *ngIf="addressForm?.get('district')?.touched && addressForm?.get('district')?.errors?.required"
        class="p-error block"
      >
        Bairro Obrigatório
      </small> -->
    </div>
  </div>

  <div class="form-group">
    <div class="form-control">
      <label for="street">{{ "STREET" | translate }} {{ required ? '*' : '' }}</label>
      <input
        pInputText
        name="street"
        formControlName="street"
        maxlength="50"
        [pTooltip]="getErrorTooltip(addressForm.get('street'))"
        tooltipPosition="bottom"
      />
      <!-- <small
        *ngIf="addressForm?.get('street')?.touched && addressForm?.get('street')?.errors?.required"
        class="p-error block"
      >
        Rua Obrigatória
      </small> -->
    </div>

    <div class="form-control">
      <label for="number">{{ "NUMBER" | translate }} {{ required ? '*' : '' }}</label>
      <input
        pInputText
        name="number"
        formControlName="number"
        maxlength="10"
        [pTooltip]="getErrorTooltip(addressForm.get('number'))"
        tooltipPosition="bottom"
      />
      <!-- <small
        *ngIf="addressForm?.get('number')?.touched && addressForm?.get('number')?.errors?.required"
        class="p-error block"
      >
        Número Obrigatório
      </small> -->
    </div>

    <div class="form-control">
      <label for="complement">{{ "COMPLEMENT" | translate }}</label>
      <input
        pInputText
        name="complement"
        formControlName="complement"
        maxlength="50"
      />
    </div>
  </div>
</div>
